export const redirects = [
  {
    path: "/new-home",
    redirect: to => ({ name: "index", query: to.query, hash: to.hash }),
  },
  {
    path: "/portal",
    redirect: to => ({ name: "home", query: to.query, hash: to.hash }),
  },
]
